import React from 'react';
import PropTypes from 'prop-types';
import Constants from '../../containers/function/constants.js';

const TasksTable = (props) => {
  const { typeTab } = props;
  const { taskManagerTabs  } = Constants;
  let showColumnClosedDate = true;
  let showColumnManager = true;
  let showColumnState = true;
  
  switch (typeTab) {
    case taskManagerTabs.TAB_NOTIFICATIONS:
      showColumnClosedDate = false;
      showColumnManager = false;
      showColumnState = false;
      break;
  }

  return (
    <div className="module-table top" style={{...props.containerStyle}}>
      <table>
        <thead>
          <tr>
            <th className="th-color left"></th>
            {(props.permits.includes("incidentannull") == true) && (<th className="th-anull left"></th>)}
            {(props.showOccurrenceDateExceptForAdminUsers==true) && (
              <th className="th-OccurrenceDate left">
                <a
                  role="button"
                  data-type="OccurrenceDate"
                  tabIndex={0}
                  onClick={props.handleSort}
                  className="th100 helpsortth"
                >
                  {props.language.tasks_manager.table.occurrenceDate}
                  <div className="sort-icons">
                    <div className="sort-icons-inner">
                      <i className={"fas fa-caret-up " + 
                        (props.sort["OccurrenceDate"]=="ASC" ? "active" : "")}/>
                      <i className={"fas fa-caret-down " + 
                        (props.sort["OccurrenceDate"]=="DESC" ? "active" : "")}/>
                    </div>
                  </div>
                  <div className="modal-indicators-info">
                    <a>
                      <i className="fas fa-question-circle" />
                      <div>
                        <p>{props.language.tasks_manager.tooltip.occurrenceDate}</p>
                      </div>
                    </a>
                  </div>
                </a>
              </th>
            )}
            <th className="th-CreatedDate left">
              <a role="button" className="helpsortth" data-type="CreatedDate" tabIndex={0} onClick={props.handleSort}>
                {props.language.tasks_manager.table.createdDate}
                <div className="sort-icons">
                  <div className="sort-icons-inner">
                    <i className={"fas fa-caret-up " + 
                      (props.sort["CreatedDate"]=="ASC" ? "active" : "")}/>
                    <i className={"fas fa-caret-down " + 
                      (props.sort["CreatedDate"]=="DESC" ? "active" : "")}/>
                  </div>
                </div>
                <div className="modal-indicators-info">
                  <div className="modal-indicators-info-tour tour-aux-light-area"/>
                  <a>
                    <i className="fas fa-question-circle" />
                    <div>
                      <p>{props.language.tasks_manager.tooltip.createdDate}</p>
                    </div>
                  </a>
                </div>
              </a>
            </th>
            {
              showColumnClosedDate && (
                <th className="th-ClosedDate left">
                  <a role="button" className="helpsortth" data-type="ClosedDate" tabIndex={0} onClick={props.handleSort}>
                    {props.language.tasks_manager.table.closedDate}
                    <div className="sort-icons">
                      <div className="sort-icons-inner">
                        <i className={"fas fa-caret-up " + 
                          (props.sort["ClosedDate"]=="ASC" ? "active" : "")}/>
                        <i className={"fas fa-caret-down " + 
                          (props.sort["ClosedDate"]=="DESC" ? "active" : "")}/>
                      </div>
                    </div>
                    <div className="modal-indicators-info">
                      <a className="green">
                        <i className="fas fa-question-circle" />
                        <div>            
                          <p>{props.language.tasks_manager.tooltip.closedDate}</p>
                        </div>
                      </a>
                    </div>
                  </a>
                </th>
              )
            }
            <th className="th-TaskType left">
              <a role="button" className="helpsortth" data-type="TaskType" tabIndex={0} onClick={props.handleSort}>
                {props.language.tasks_manager.table.type}
                <div className="sort-icons">
                  <div className="sort-icons-inner">
                    <i className={"fas fa-caret-up " + 
                      (props.sort["TaskType"]=="ASC" ? "active" : "")}/>
                    <i className={"fas fa-caret-down " + 
                      (props.sort["TaskType"]=="DESC" ? "active" : "")}/>
                  </div>
                </div>
                <div className="modal-indicators-info">
                  <a>
                    <i className="fas fa-question-circle" />
                    <div>
                      <p>{props.language.tasks_manager.tooltip.type}</p>
                    </div>
                  </a>
                </div>            
              </a>
            </th>
            <th className="th-Subtype left">
              <a
                role="button"
                data-type="Subtype"
                tabIndex={0}
                onClick={props.handleSort}
                className="th100 helpsortth"
              >
                {props.language.tasks_manager.table.subtype}
                <div className="sort-icons">
                  <div className="sort-icons-inner">
                    <i className={"fas fa-caret-up " + 
                      (props.sort["Subtype"]=="ASC" ? "active" : "")}/>
                    <i className={"fas fa-caret-down " + 
                      (props.sort["Subtype"]=="DESC" ? "active" : "")}/>
                  </div>
                </div>
                <div className="modal-indicators-info">
                  <a>
                    <i className="fas fa-question-circle" />
                    <div>
                      <p>{props.language.tasks_manager.tooltip.subtype}</p>
                    </div>
                  </a>
                </div>             
              </a>
            </th>
            <th className="th-Person left">
              <a
                role="button"
                data-type="Person"
                tabIndex={0}
                onClick={props.handleSort}
                className="th100 helpsortth"
              >
                {props.language.tasks_manager.table.person}
                <div className="sort-icons">
                  <div className="sort-icons-inner">
                    <i className={"fas fa-caret-up " + 
                      (props.sort["Person"]=="ASC" ? "active" : "")}/>
                    <i className={"fas fa-caret-down " + 
                      (props.sort["Person"]=="DESC" ? "active" : "")}/>
                  </div>
                </div>
                <div className="modal-indicators-info">
                  <a>
                    <i className="fas fa-question-circle" />
                    <div>
                      <p>{props.language.tasks_manager.tooltip.person}</p>
                    </div>
                  </a>
                </div>             
              </a>
            </th>
            <th className="th-Vehicle left">
              <a
                role="button"
                data-type="Vehicle"
                tabIndex={0}
                onClick={props.handleSort}
                className="th100 helpsortth"
              >
                {props.language.tasks_manager.table.vehicle}
                <div className="sort-icons">
                  <div className="sort-icons-inner">
                    <i className={"fas fa-caret-up " + 
                      (props.sort["Vehicle"]=="ASC" ? "active" : "")}/>
                    <i className={"fas fa-caret-down " + 
                      (props.sort["Vehicle"]=="DESC" ? "active" : "")}/>
                  </div>
                </div>
                <div className="modal-indicators-info">
                  <a>
                    <i className="fas fa-question-circle" />
                    <div>
                      <p>{props.language.tasks_manager.tooltip.vehicle}</p>
                    </div>
                  </a>
                </div>             
              </a>
            </th>
            {
              showColumnManager && (
                <th className="th-Manager left">
                  <a
                    role="button"
                    data-type="Manager"
                    tabIndex={0}
                    onClick={props.handleSort}
                    className="th100 helpsortth"
                  >
                    {props.language.tasks_manager.table.manager}
                    <div className="sort-icons">
                      <div className="sort-icons-inner">
                        <i className={"fas fa-caret-up " + 
                          (props.sort["Manager"]=="ASC" ? "active" : "")}/>
                        <i className={"fas fa-caret-down " + 
                          (props.sort["Manager"]=="DESC" ? "active" : "")}/>
                      </div>
                    </div>
                    <div className="modal-indicators-info left">
                      <a>
                        <i className="fas fa-question-circle" />
                        <div>
                          <p>{props.language.tasks_manager.tooltip.manager}</p>
                        </div>
                      </a>
                    </div>             
                  </a>
                </th>
              )
            }
            {
              showColumnState && (
                <th className="th-State center fix-super-wide">
                  <a className="noLink">
                    {props.language.tasks_manager.table.state}
                    <div className="modal-indicators-info left">
                      <a className="green">
                        <i className="fas fa-question-circle" />
                        <div>            
                          <p>{props.language.tasks_manager.tooltip.desvHelp1}</p>
                          {props.language.tasks_manager.tooltip.desvCat1Label && (
                            <p>
                              <span className="yellow">
                              {props.language.tasks_manager.tooltip.desvCat1Label}
                              </span>
                              {' '}{props.language.tasks_manager.tooltip.desvCat1LabelDesc}
                            </p>
                          )}
                          {props.language.tasks_manager.tooltip.desvCat2Label && (
                            <p>
                              <span className="green">
                              {props.language.tasks_manager.tooltip.desvCat2Label}
                              </span>
                              {' '}{props.language.tasks_manager.tooltip.desvCat2LabelDesc}
                            </p>
                          )}
                          {props.language.tasks_manager.tooltip.desvCat3Label && (
                            <p>
                              <span className="purple">
                              {props.language.tasks_manager.tooltip.desvCat3Label}
                              </span>
                              {' '}{props.language.tasks_manager.tooltip.desvCat3LabelDesc}
                            </p>
                          )}
                          {props.language.tasks_manager.tooltip.desvCat4Label && (
                            <p>
                              <span className="red">
                              {props.language.tasks_manager.tooltip.desvCat4Label}
                              </span>
                              {' '}{props.language.tasks_manager.tooltip.desvCat4LabelDesc}
                            </p>
                          )}
                          {props.language.tasks_manager.tooltip.desvCat5Label && (
                            <p>
                              <span className="grey">
                              {props.language.tasks_manager.tooltip.desvCat5Label}
                              </span>
                              {' '}{props.language.tasks_manager.tooltip.desvCat5LabelDesc}
                            </p>
                          )}
                          {props.language.tasks_manager.tooltip.desvCat6Label && (
                            <p>
                              <span className="lightblue">
                              {props.language.tasks_manager.tooltip.desvCat6Label}
                              </span>
                              {' '}{props.language.tasks_manager.tooltip.desvCat6LabelDesc}
                            </p>
                          )}
                        </div>
                      </a>
                    </div>   
                  </a>
                </th>
              )
            }
          </tr>
        </thead>
        <tbody>
          {props.datos && props.datos.map((item, i) => {
            return (
              <tr
                key={`${i}`}
                data-id={item.id}
                className={"hover" + 
                  (item.id in props.annulCheckedTasks ? " task_to_annul" : "") +
                  (props.activeTask && props.activeTask.id==item.id ? " active_task" : "")
                }
                onClick={ (e) => { props.handleClickTask(item.id) }}
              >
                <td className="td-color first">
                  <div>
                    <div>
                      <span 
                        style={{
                          backgroundColor: Constants.taskManagerStateColorRange[item.state.key.toUpperCase()]
                        }}
                        className="font16"
                      />
                    </div>
                  </div>
                </td>
                {(props.permits.includes("incidentannull") == true) && (
                  <td className="td-anull"><div><div>
                    <label className="matter-checkbox">
                      {(item.state && item.state.key!="Notification" && item.state.key!="Annulled") && (
                        <input 
                          type="checkbox"
                          data-id={item.id}
                          onClick={(event) => {event.stopPropagation();}}
                          onChange={props.handleAddAnnulTask}
                          checked={item.id in props.annulCheckedTasks ? true : false}
                        />
                      )}
                      <span></span>
                    </label>
                  </div></div></td>
                )}
                {(props.showOccurrenceDateExceptForAdminUsers==true) && (
                  <td className="td-OccurrenceDate"><div><div>
                    {item.occurrenceDate ? item.occurrenceDate : ""}
                  </div></div></td>
                )}
                <td className="td-CreatedDate left"><div><div>{item.createdDate}</div></div></td>
                {
                  showColumnClosedDate && (
                    <td className="td-ClosedDate left"><div><div>{item.closedDate ? item.closedDate : ""}</div></div></td>
                  )
                }
                <td className="td-TaskType left"><div><div>{item.type}</div></div></td>
                <td className="td-Subtype left"><div><div>{item.subtype}</div></div></td>
                <td className="td-Person left"><div><div>{item.personAlias}</div></div></td>
                <td className="td-Vehicle left"><div><div>{item.vehicleAlias}</div></div></td>
                {
                  showColumnManager && (
                    <td className="td-Manager left"><div><div>{item.managerAlias}</div></div></td>
                  )
                }
                {
                  showColumnState && (
                    <td className="td-State center"><div>
                      <div style={{
                          color: Constants.taskManagerStateColorRange[item.state.key.toUpperCase()]
                        }}>
                        {item.state.label}
                        {item.state.timeElapsed ? (
                          <span className="state_time_elapsed">
                            <div className="state-clock"/>{item.state.timeElapsed}
                          </span>)
                        : null}
                      </div>
                    </div></td>
                  )
                }
              </tr>
            );
          })}
        </tbody>
      </table>
      {props.loadingTable && (
        <div className="loading-table">
          <h6>
            <i className="fas fa-spinner fa-spin" />
          </h6>
        </div>
      )}
      {props.pag >= props.count.pages && (
        <div className="loading-table">
          <h6>{props.language.tasks_manager.table.noData}</h6>
        </div>
      )}
    </div>
  )
};

TasksTable.propTypes = {
  pag: PropTypes.number.isRequired,
  count: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  loadingTable: PropTypes.bool.isRequired,
  language: PropTypes.oneOfType([PropTypes.object]).isRequired,
  datos: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.array
  ]).isRequired
};

export default TasksTable;


// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/tasksTable.jsx